import * as _ from 'lodash-es';
import axios from 'axios';
import { getRootDomain } from '../../../utils/common/url';

export default class TabularData {
	static normalized(lookUpHelper, productPath, resolve, reject) {
		// product CFs paths are not translate so we need to replace the lang path based on URL
		const currLoc = location.pathname;
		const currLang = currLoc.match(/\/\w{2}-\w{2}\//gm);
		const pathLang = productPath.match(/\/\w{2}-\w{2}\//gm);

		if (currLang?.[0] !== pathLang?.[0]) {
			productPath.replace(pathLang, currLang);
		}
		let csvPath = productPath.indexOf('.csv') > -1 ? productPath : `${productPath}/ProductComparisonTemplate.csv`;

		axios
			.get(`/bin/esri/getCsvResponse?csvPath=/${csvPath}`)
			.then(function (response) {
				if (!response.data) {
					console.error('%c No comparsion data was found, make sure csv is added to directory! ', 'background: orange; color: black');
					resolve('no_data_back');
				} else {
					const dataString = response.data;
					const lastCommaIssue = /,}/gi;
					const reformatedDataStr = dataString.replace(lastCommaIssue, '}');
                    const reformatedDataObj = JSON.parse(reformatedDataStr);
                    const isEsriIncStore = getRootDomain(location.host) === 'esri.com';
					const data = isEsriIncStore ? fixKeyPath(reformatedDataObj) : reformatedDataObj;
					let endPoint = normalizeData(data);
					resolve(endPoint);
				}
			})
			.catch(function (error) {
				reject(error);
			});

		/** Product CFs paths are not translated so we need to replace the lang path based on URL */
		function fixKeyPath(data) {
			if (!data) return data;

			const keys = Object.keys(data);
			if (!keys || !keys.length) return data;

			keys.forEach((key) => {
				const keyPathLang = key.match(/\/\w{2}-\w{2}\//gm);
				if (!keyPathLang?.[0] || !currLang?.[0] || keyPathLang?.[0] === currLang?.[0]) return;

				const newKey = key.replace(keyPathLang, currLang);
				data[newKey] = data[key];
				delete data[key];
			});

			return data;
		}

		function normalizeData(endPoint) {
			let normalizedData = {};
			// get sections
			let data = endPoint || null;
			if (data) {
				let sectionsArr = data[Object.keys(data)[0]];
				normalizedData.sections = sectionsArr.map((sec) => {
					return Object.keys(sec)[0];
				});
				// get product keys
				normalizedData.products = [];
				lookUpHelper.pathArr.forEach((path) => {
					if (data[path] !== undefined) {
						normalizedData.products = [...normalizedData.products, { path: path, id: lookUpHelper[path] }];
					}
				});
				// pull raw data
				let reformattedSeciont = {};
				normalizedData.products.forEach((prod) => {
					let prodSecArr = data[prod.path];
					if (prodSecArr && prodSecArr.length) {
						prodSecArr.forEach((sec) => {
							var sectTitle = Object.keys(sec)[0];
							var rows = sec[sectTitle];
							var rowTitles = Object.keys(rows);
							rowTitles.forEach((rowT) => {
								reformattedSeciont[sectTitle] = reformattedSeciont[sectTitle] || {};
								reformattedSeciont[sectTitle][rowT] = reformattedSeciont[sectTitle][rowT] || [];
								reformattedSeciont[sectTitle][rowT].push({ id: prod.id, path: prod.path, value: rows[rowT] });
							});
						});
					}
				});
				// create section data obj
				normalizedData.sectionsData = reformattedSeciont;
			} else {
				console.warn('Comparison table data missing | TabularData.js');
				return null;
			}
			return normalizedData;
		}
	}
}
